import { useTheme } from '../../contexts/ThemeContext';
import Button from './ui/Button';
import './ThemeToggle.css';

const SunIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="M4.93 4.93 6.34 6.34" />
    <path d="M17.66 17.66 19.07 19.07" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="M4.93 19.07 6.34 17.66" />
    <path d="M17.66 6.34 19.07 4.93" />
  </svg>
);

const MoonIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const ThemeToggle = ({ labelHidden = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const nextTheme = isDark ? 'light' : 'dark';
  const Icon = nextTheme === 'dark' ? MoonIcon : SunIcon;

  return (
    <Button
      variant="ghost"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Switch to ${nextTheme} mode`}
      title={`Switch to ${nextTheme} mode`}
    >
      <Icon className="theme-toggle__icon" />
      {!labelHidden && (
        <span className="theme-toggle__label">Switch to {nextTheme} mode</span>
      )}
    </Button>
  );
};

export default ThemeToggle;
